export default __webpack_public_path__ + "ConsentForm2.html";